/**
 * .product-description（商品詳細本文）の先頭要素を
 * .product__catchcopy へ移し、説明文側からは除去する。
 * 空の要素（&nbsp; や空白のみ）は削除して次の要素を対象にする。
 */
function isEmptyCatchcopyNode(el) {
  if (!el) return true;

  const text = (el.textContent || '')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (text) return false;

  // 画像・動画などテキスト以外の実コンテンツがあれば空とみなさない
  return !el.querySelector('img, svg, video, iframe, picture, object, embed');
}

function takeFirstMeaningfulChild(descriptionEl) {
  let child = descriptionEl.firstElementChild;

  while (child) {
    if (!isEmptyCatchcopyNode(child)) {
      return child;
    }

    const empty = child;
    child = child.nextElementSibling;
    empty.remove();
  }

  return null;
}

function initProductCatchcopy() {
  const descriptionEl =
    document.querySelector('.cm-product-description__body.product-description') ||
    document.querySelector('.cm-product-description__body') ||
    document.querySelector('.product-description') ||
    document.querySelector('.product__description');

  document.querySelectorAll('.product__catchcopy').forEach((catchcopyEl) => {
    if (catchcopyEl.dataset.cmProductCatchcopyInit === 'true') return;

    catchcopyEl.dataset.cmProductCatchcopyInit = 'true';

    if (!descriptionEl) {
      catchcopyEl.hidden = true;
      return;
    }

    const firstChild = takeFirstMeaningfulChild(descriptionEl);
    if (!firstChild) {
      catchcopyEl.hidden = true;
      return;
    }

    const content = firstChild.innerHTML.trim();
    if (!content) {
      catchcopyEl.hidden = true;
      firstChild.remove();
      return;
    }

    catchcopyEl.innerHTML = content;
    catchcopyEl.hidden = false;
    firstChild.remove();
  });
}

document.addEventListener('DOMContentLoaded', initProductCatchcopy);

document.addEventListener('shopify:section:load', initProductCatchcopy);
